import type { CostIndicatorsPayload } from '@Application/Indicators/Actions/costIndicatorsFetched';
import IndicatorComparisonView from '@UI/Store/Indicators/Views/IndicatorComparisonView';
import IndicatorPeriodView from '@UI/Store/Indicators/Views/IndicatorPeriodView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class CostIndicatorsView {
	readonly queryKey: string;
	readonly period: IndicatorPeriodView;
	readonly total: IndicatorComparisonView;
	readonly callCount: number | null;
	readonly unpricedCallCount: number | null;
	readonly hasActivity: boolean;
	readonly hasUnpricedCalls: boolean;
	readonly isEntirelyUnpriced: boolean;

	constructor(payload: CostIndicatorsPayload) {
		this.queryKey = payload.queryKey;
		this.period = new IndicatorPeriodView(payload.period);
		this.total = new IndicatorComparisonView(payload.total);
		this.callCount = payload.callCount;
		this.unpricedCallCount = payload.unpricedCallCount;
		this.hasActivity = payload.hasActivity;
		this.hasUnpricedCalls = payload.hasUnpricedCalls;
		this.isEntirelyUnpriced = payload.isEntirelyUnpriced;

		Object.freeze(this);
	}

	get isEmpty(): boolean {
		return !this.hasActivity;
	}
}

export default CostIndicatorsView;
